// extracted by mini-css-extract-plugin
module.exports = {"container":"EditAndDeleteButtons_container__10SSh","sending":"EditAndDeleteButtons_sending__3LmqF"};